/**
 * Platformbeheer (/admin) — uitsluitend rol `superadmin`.
 * Tenant-accountbeheer (`admin`) gebruikt o.a. Account → Facturatie, niet dit gebied.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

export function AdminGuard() {
  const { isSuperAdmin, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <div className="py-12 text-center text-text-muted">Laden...</div>;
  if (!user?.authenticated) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  if (!isSuperAdmin) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
